import { render } from "./ChooseWordToChange.vue?vue&type=template&id=5646266e"
import script from "./ChooseWordToChange.vue?vue&type=script&lang=js"
export * from "./ChooseWordToChange.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Questionnaire/Question/ChooseWordToChange.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5646266e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5646266e', __exports__)) {
    api.reload('5646266e', __exports__)
  }
  
  module.hot.accept("./ChooseWordToChange.vue?vue&type=template&id=5646266e", () => {
    api.rerender('5646266e', render)
  })

}


export default __exports__